import {
  HOME_FAQS,
  HOME_PRICING_PREVIEW,
  HOW_IT_WORKS_OVERVIEW_GROUPS,
  HOW_IT_WORKS_PAGE_NOTES,
  HOW_IT_WORKS_PAGE_STEPS,
  PAGE_METADATA,
} from "./publicSiteContent";

const FR_HOME_FAQS = [
  {
    question: "AfterMe est-il un simple espace de stockage infonuagique ?",
    answer:
      "Non. Il s'agit d'un centre de controle pour l'heritage numerique et la transition des comptes, ou contenu prive, contacts de confiance, regles de diffusion et consignes familiales fonctionnent ensemble.",
  },
  {
    question: "AfterMe fermera-t-il automatiquement tous les comptes en ligne de ma famille ?",
    answer:
      "Non. Chaque grande plateforme a son propre processus officiel de memorialisation, de fermeture, d'exportation ou de transfert. AfterMe vous aide a preparer les consignes, suivre l'intention et guider les personnes responsables.",
  },
  {
    question: "Les contacts de confiance voient-ils tout automatiquement ?",
    answer:
      "Non. Les contacts de confiance font partie du plan, mais le contenu sensible doit toujours suivre les conditions de diffusion et les regles de destinataires que vous fixez.",
  },
  {
    question: "Comment la preuve de vie est-elle geree ?",
    answer:
      "AfterMe doit etre compris comme une planification de confirmation d'inactivite et de verification respectueuse de la vie privee, et non comme une detection de vie intrusive. Les parcours de diffusion peuvent inclure des delais de grace, la confirmation par un contact de confiance et une revision manuelle.",
  },
  {
    question: "A qui s'adresse AfterMe ?",
    answer:
      "A des personnes et des familles qui veulent plus qu'un espace de stockage : des consignes privees, des dossiers proteges, des contacts de confiance et un plan plus clair pour les comptes numeriques et les profils en ligne.",
  },
];

const FR_HOME_PRICING_PREVIEW = [
  {
    name: "Mensuel",
    price: "$9.99",
    period: "/ mois",
    summary:
      "Une option mensuelle douce si vous souhaitez continuer a avancer a votre rythme.",
    highlights: [
      "Journaux prives, lettres et cartographie familiale",
      "Medias proteges avec des controles de partage plus attentifs",
      "Une suite simple lorsque vous serez pret a continuer",
    ],
  },
  {
    name: "Annuel",
    price: "$99.99",
    period: "/ an",
    summary:
      "Une option plus stable pour les familles qui recherchent de la continuite et de la serenite.",
    highlights: [
      "Tout ce qui est inclus dans Mensuel, avec un coffre-fort plus riche",
      "Meilleure valeur pour une preparation familiale sur toute l'annee",
      "Concu pour les familles qui veulent un lieu durable et rassurant",
    ],
    featured: true,
  },
];

const FR_HOW_IT_WORKS_PAGE_STEPS = [
  {
    step: "01",
    title: "Creez votre compte",
    body:
      "Commencez avec un compte prive que vous controlez. AfterMe prend deja en charge le courriel et le mot de passe, la connexion Google et les liens de connexion a usage unique.",
  },
  {
    step: "02",
    title: "Ajoutez souhaits, dossiers et contenu prive",
    body:
      "Rassemblez journaux, instructions familiales, medias proteges et dossiers dont votre famille pourrait avoir besoin lorsque le temps et la clarte comptent.",
  },
  {
    step: "03",
    title: "Attribuez des contacts de confiance",
    body:
      "Cartographiez les membres de la famille et designez les personnes qui devront verifier, recevoir ou executer certaines parties de votre plan.",
  },
  {
    step: "04",
    title: "Definissez les regles de diffusion",
    body:
      "Precisez qui doit recevoir quoi et dans quelles circonstances, afin que le contenu soit diffuse selon votre intention plutot que selon des suppositions.",
  },
  {
    step: "05",
    title: "Choisissez l'inactivite ou les parcours de verification",
    body:
      "Preparez la diffusion autour d'une confirmation d'inactivite de type preuve de vie, d'une preuve familiale ou d'autres parcours axes sur la verification manuelle.",
  },
  {
    step: "06",
    title: "Preparez les actions de transition des comptes",
    body:
      "Listez les services qui comptent et documentez si chacun doit etre memorialise, ferme, exporte, transfere ou laisse intact.",
  },
];

const FR_HOW_IT_WORKS_PAGE_NOTES = [
  "AfterMe est concu pour reduire la confusion familiale, non pour remplacer des conseils juridiques ou successoraux professionnels.",
  "Les grands services en ligne utilisent tous leur propre processus officiel; AfterMe met donc l'accent sur la planification, le suivi et l'orientation.",
  "Les elements les plus sensibles devraient toujours suivre les regles de diffusion les plus strictes de votre plan.",
];

const FR_HOW_IT_WORKS_OVERVIEW_GROUPS = [
  {
    steps: ["01", "02"],
    title: "Proteger ce qui compte",
    body: "Creez votre compte et rassemblez les souhaits, dossiers et contenus prives que votre famille ne devrait pas avoir a reconstruire plus tard.",
  },
  {
    steps: ["03", "04"],
    title: "Choisir qui participe",
    body: "Attribuez des personnes de confiance, des destinataires et des regles de diffusion afin que chacun connaisse son role avant qu'un moment difficile n'arrive.",
  },
  {
    steps: ["05", "06"],
    title: "Preparer ce qui se passera plus tard",
    body: "Definissez les parcours de verification et les actions de transition des comptes afin que votre plan devienne un guide, et non un simple stockage.",
  },
];

const FR_PAGE_METADATA = {
  home: {
    title: "AfterMe | Continuite familiale et planification de l'heritage numerique",
    description:
      "Aidez votre famille a retrouver souvenirs, documents, volontes et personnes de confiance dans un seul espace securise quand la clarte compte le plus.",
  },
  how: {
    title: "Comment fonctionne AfterMe | Contacts de confiance, regles de diffusion et planification numerique",
    description:
      "Voyez comment AfterMe aide les familles a preparer des dossiers prives, attribuer des contacts de confiance, planifier les flux de memorialisation des comptes et organiser la planification numerique de fin de vie.",
  },
  security: {
    title: "AfterMe Securite et vie privee | Controles d'acces et de diffusion en langage clair",
    description:
      "Decouvrez comment AfterMe garde les dossiers familiaux sensibles prives, comment les contacts de confiance s'integrent a votre plan et comment la diffusion est geree avec soin.",
  },
  plan: {
    title: "AfterMe Tarification | Plans de planification d'heritage numerique pour les familles",
    description:
      "Comparez les forfaits Mensuel et Annuel d'AfterMe pour la planification securisee de documents familiaux, les contacts de confiance, les regles de diffusion et l'organisation de l'heritage numerique — avec une periode d'introduction et la possibilite d'annuler avant le renouvellement.",
  },
  terms: {
    title: "AfterMe Conditions d'utilisation",
    description:
      "Consultez les Conditions d'utilisation d'AfterMe, une plateforme canadienne de planification d'heritage numerique pour dossiers proteges, consignes familiales et planification de diffusion.",
  },
  auth: {
    title: "AfterMe Connexion | Accedez a votre plan d'heritage numerique",
    description:
      "Connectez-vous a AfterMe pour gerer votre plan prive d'heritage numerique, vos contacts de confiance, vos consignes familiales et votre contenu sensible a la diffusion.",
  },
};

const EN_COPY = {
  locale: "en",
  htmlLang: "en-CA",
  metadata: PAGE_METADATA,
  toggle: {
    label: "Language",
    english: "EN",
    french: "FR",
  },
  nav: {
    product: "Product",
    how: "How it works",
    security: "Security",
    pricing: "Pricing",
    faq: "FAQ",
    signIn: "Sign in",
    getStarted: "Get started",
    myDashboard: "My dashboard",
    signOut: "Sign out",
    backToHome: "Back to home",
  },
  notices: {
    planLinkCopied:
      "Link copied. Send it to anyone—they can open this page signed in or as a guest.",
    linkCopyFailed:
      "Could not copy automatically. Copy the address from your browser bar.",
    termsLinkCopied:
      "Terms link copied. Share it with anyone who needs the full Terms of Service.",
    checkoutStub: (label) => `Checkout for ${label} is not wired up yet.`,
  },
  homeHero: {
    eyebrow: "Family continuity & digital legacy",
    title: "Help your family when they need you most.",
    body:
      "Securely preserve memories, wishes, trusted guidance, and important information for the people you care about.",
    support: "Private by design. Shared only with the people you choose.",
    primaryCta: "Start your legacy plan",
    secondaryCta: "See how it works",
  },
  home: {
    video: {
      title: "See how AfterMe helps your family",
      description:
        "A short look at how AfterMe keeps your memories, wishes, and guidance ready in one calm, private space.",
      ariaLabel: "AfterMe homepage walkthrough video",
      devPlaceholderTitle: "Homepage video preview",
      devPlaceholderBody:
        "Add a homepage video URL in local development to preview the walkthrough here.",
    },
    why: {
      eyebrow: "Why AfterMe exists",
      title: "A calmer way to leave clarity behind.",
      body:
        "When families need clarity most, important details are often scattered. AfterMe brings memories, wishes, and key information together in one secure place.",
      points: [
        "Important documents are easier to find when they live together.",
        "Personal wishes do not get lost across notes, emails, and devices.",
        "Memories matter too, not just paperwork.",
      ],
    },
    pillars: {
      eyebrow: "What your plan can hold",
      title: "What your plan helps protect",
      body:
        "Keep the essentials together without overwhelming the people you care about.",
      cards: [
        {
          icon: "🖼️",
          title: "Preserve memories",
          body: "Keep photos, notes, and personal messages in one private place.",
        },
        {
          icon: "📄",
          title: "Organize important documents",
          body: "Store the documents your family may need without scattering them across devices.",
        },
        {
          icon: "🤝",
          title: "Share wishes with trusted people",
          body: "Choose who should help, receive guidance, or stay informed later.",
        },
        {
          icon: "🧭",
          title: "Guide your family when needed",
          body: "Leave clearer direction so loved ones are not left guessing under pressure.",
        },
      ],
    },
    steps: {
      title: "How it works",
      body: "Start simply, then build at your own pace.",
      items: [
        {
          step: "01",
          title: "Add what matters",
          body: "Start with one memory, one document, or one wish that would help later.",
        },
        {
          step: "02",
          title: "Choose trusted people",
          body: "Choose who should help, receive something, or stay informed later.",
        },
        {
          step: "03",
          title: "Keep everything ready",
          body: "Keep it private now so it is easier to find when it is needed.",
        },
      ],
      cta: "View the full walkthrough",
    },
    privacy: {
      eyebrow: "Trust & privacy",
      title: "Private by design. Shared with care.",
      body:
        "Sensitive family information should stay protected, understandable, and fully under your control.",
      cards: [
        {
          icon: "🔒",
          title: "Encrypted storage",
          body: "Your memories, documents, and notes are kept in protected storage.",
        },
        {
          icon: "🛡️",
          title: "Private access controls",
          body: "You decide who can see what, instead of sharing everything at once.",
        },
        {
          icon: "👨‍👩‍👧",
          title: "Trusted people only",
          body: "Choose the family members or trusted contacts who matter in your plan.",
        },
        {
          icon: "⏳",
          title: "Nothing shared automatically",
          body: "Release can follow the timing and checks you choose for sensitive items.",
        },
      ],
      cta: "Review privacy and access",
    },
    pricing: {
      title: "Choose the pace that fits your family",
      body:
        "Begin gently, explore privately, and choose the plan that feels right only when you are ready.",
      cards: HOME_PRICING_PREVIEW,
      primaryCta: "See full plans & pricing",
      secondaryCta: "Create an account",
      featuredBadge: "Popular",
    },
    faq: {
      title: "Questions families ask first",
      body: "A few quick answers before you start.",
      items: HOME_FAQS.slice(0, 3),
    },
    finalCta: {
      eyebrow: "Start gently",
      title: "Start with one memory, one document, or one wish.",
      body:
        "You do not need everything ready today. Start small, then build with care.",
      primaryCta: "Create your secure space",
      secondaryCta: "View pricing",
    },
  },
  productShowcase: {
    ariaLabel: "AfterMe product overview",
    snapshotKicker: "Inside your secure space",
    snapshotTitle: "Memories, documents, trusted people, and wishes — ready when clarity matters.",
    snapshotStatus: "Private by design",
    planItems: [
      {
        title: "Preserve memories",
        body: "Keep photos, personal notes, and meaningful messages together in a calm private vault.",
        badge: "Memories",
      },
      {
        title: "Organize documents",
        body: "Store important documents in one place so your family does not have to search later.",
        badge: "Documents",
      },
      {
        title: "Trusted family guidance",
        body: "Choose who may help, verify, or receive sensitive guidance when the time is right.",
        badge: "Trusted people",
      },
    ],
    signalChips: [],
    transitionKicker: "What your family can find",
    transitionTitle: "A clearer handoff, prepared with care",
    transitionItems: [
      { service: "Memories", action: "Personal stories" },
      { service: "Documents", action: "Important details" },
      { service: "Trusted people", action: "Ready to help" },
    ],
    transitionStatusLabel: "Family continuity highlights",
    transitionStatuses: ["Private by default", "Shared with permission", "Kept ready"],
  },
  howPage: {
    kicker: "How it works",
    title: "A calmer way to prepare what your family may need later.",
    lead:
      "AfterMe is designed to help you prepare private content, family guidance, and digital account decisions in one place so the people you trust are not left to improvise.",
    stepsHeading: "Six simple steps",
    stepsLead:
      "The experience is built around clarity: protect what matters, choose who is involved, and define what should happen before a difficult moment arrives.",
    steps: HOW_IT_WORKS_PAGE_STEPS,
    overviewAria: "How it works at a glance",
    overviewKicker: "At a glance",
    overviewTitle: "From private preparation to a clearer family handoff.",
    overviewGroups: HOW_IT_WORKS_OVERVIEW_GROUPS,
    notesHeading: "Important context",
    notes: HOW_IT_WORKS_PAGE_NOTES,
    ctaKicker: "Ready to continue?",
    ctaTitle: "Start with privacy, trusted contacts, and clear release intent.",
    ctaBody:
      "AfterMe is for families who want more than file storage. It is for people who want a clearer plan.",
    primaryCta: "Get started",
    pricingCta: "View pricing",
    securityCta: "Review security",
  },
  securityPage: {
    kicker: "Security & privacy",
    title: "Private by default. Shared with care.",
    lead:
      "Your family information stays under your control and is only shared intentionally. AfterMe is built to feel private, calm, and easy to understand.",
    protectsHeading: "What stays protected",
    protectsLead:
      "Keep the essentials together, without making sensitive family information feel exposed.",
    protectedItems: [
      {
        title: "Private content",
        body: "Journals, letters, memories, and notes stay personal until you choose otherwise.",
      },
      {
        title: "Trusted people",
        body: "You decide who belongs in your plan and what role each person should have later.",
      },
      {
        title: "Release with care",
        body: "Specific items become accessible only through the timing and checks you set.",
      },
    ],
    reassuranceAria: "Privacy reassurance panel",
    reassuranceKicker: "Calm privacy snapshot",
    reassuranceTitle: "A simple privacy path for family information.",
    reassurancePoints: [
      {
        title: "Private by default",
        body: "Everything begins in your own space, not in public view.",
      },
      {
        title: "Trusted people only",
        body: "Only selected people are connected to your plan.",
      },
      {
        title: "Release with care",
        body: "Access follows your rules instead of happening automatically.",
      },
    ],
    reassuranceFlowLabel: "Security flow",
    reassuranceFlow: ["Private by default", "Trusted people only", "Release with care"],
    principlesHeading: "Simple privacy principles",
    principlesItems: [
      {
        title: "Private by default",
        body: "Your materials stay in your account until you intentionally prepare them for someone else.",
      },
      {
        title: "Trusted people only",
        body: "Being part of your plan does not mean seeing everything.",
      },
      {
        title: "Intentional sharing",
        body: "You choose what is shared, with whom, and under what conditions.",
      },
    ],
    contactsHeading: "What trusted people can and cannot do",
    trustedContacts: [
      {
        title: "Trusted people can",
        points: [
          "Help confirm release conditions",
          "Receive specific shared items",
          "Be part of your family continuity plan",
        ],
      },
      {
        title: "Trusted people cannot",
        points: [
          "Automatically access everything",
          "Open protected content early",
          "Control unrelated third-party accounts",
        ],
      },
    ],
    verificationHeading: "How intentional release works",
    verificationLead:
      "The goal is to reduce confusion, not rush anything. Sharing stays tied to the people and checks you choose.",
    verificationPaths: [
      { title: "You create private content", body: "Write letters, save memories, or organize important family information." },
      { title: "You choose trusted people", body: "Connect the people who may help, receive guidance, or stay informed later." },
      { title: "Your release rules are checked", body: "Timing, confirmation, and review steps follow the path you prepared." },
      { title: "Specific items become accessible intentionally", body: "Only the items meant for that moment move forward." },
    ],
    reviewHeading: "You remain in control of",
    reviewPoints: [
      "who can receive content",
      "what stays private",
      "release timing",
      "family access structure",
    ],
    ctaKicker: "Build with clarity",
    ctaTitle: "Build your family space with clarity.",
    ctaBody:
      "Start privately, choose trusted people carefully, and organize what matters at your own pace.",
    primaryCta: "Create your secure space",
    howCta: "See how it works",
    pricingCta: "View pricing",
  },
  pricingPage: {
    heroEyebrow: "Start gently",
    heroTitle: "Begin your private family space.",
    heroBody:
      "Organize memories, important documents, trusted contacts, and personal guidance at your own pace.",
    heroPrimaryCta: "Create your secure space",
    heroSecondaryCta: "See what you can explore",
    heroAsideKicker: "Introductory access",
    heroAsideTitle: "Take your time getting started.",
    heroAsidePoints: [
      "Create your private family space",
      "Add memories, journals, and trusted contacts",
      "Explore your family map and planning tools",
      "Decide on a plan only when you are ready",
    ],
    copyLink: "Copy page link",
    backToDashboard: "Back to dashboard",
    signIn: "Sign in",
    promoTitle: "Start slowly and explore privately",
    promoBody:
      "You can begin organizing memories, documents, trusted people, and personal guidance before making any long-term plan decision.",
    promoAssurance: "No surprise billing or automatic charges.",
    valueTitle: "What you can begin organizing now",
    valueCards: [
      {
        title: "Preserve memories",
        body: "Keep photos, notes, and meaningful family moments together in one private space.",
      },
      {
        title: "Organize important documents",
        body: "Keep family information and important records easier to find when clarity matters.",
      },
      {
        title: "Choose trusted people",
        body: "Decide who may help, receive guidance, or stay informed when needed.",
      },
      {
        title: "Prepare personal guidance",
        body: "Write journals, letters, and wishes in a calm place you can return to anytime.",
      },
    ],
    heading: "Choose a pace that feels right",
    comparisonNote:
      "Both plans support the same calm setup experience. Yearly simply gives families more room and longer-term value when they are ready.",
    trustTitle: "Built for sensitive family information",
    trustPoints: [
      "Encrypted storage for sensitive memories and records",
      "Private access controls that stay under your control",
      "Nothing is shared automatically",
      "Trusted people only, based on your settings",
      "AfterMe does not provide legal, tax, medical, or estate advice",
    ],
    trustFootnote:
      "You can begin quietly now and choose a paid plan later when it feels right.",
    planPrice: {
      introLabel: "Start now with introductory access",
      futurePrefix: "Later",
      futureAria: "Start now with introductory access. Later {fullLabel}.",
      futureCaption:
        "No surprise billing or automatic charges.",
    },
    tiles: [
      {
        id: "monthly",
        name: "Monthly",
        badge: "Start gradually",
        price: "$9.99",
        period: "/month",
        lead: "A gentle monthly option when you want to keep building at your own pace.",
        features: [
          "Preserve memories, photos, and important family information",
          "Private journals, profile, and family map",
          "Choose trusted people who can help when needed",
          "Up to 2 GB secure media storage",
        ],
        cta: "Select Monthly",
        checkoutLabel: "Monthly access when paid plans begin",
      },
      {
        id: "annual",
        name: "Yearly",
        badge: "Best for long-term peace of mind",
        price: "$99.99",
        period: "/year",
        lead: "A steadier path for families who want to settle into one long-term home for important information.",
        features: [
          "Everything in Monthly",
          "More room for memories, photos, and documents",
          "Priority access to new safety features",
          "Designed for longer-term family continuity",
        ],
        cta: "Select Yearly",
        checkoutLabel: "Yearly access when paid plans begin",
        featured: true,
      },
    ],
    enrollment: {
      detailsTitle: "Continue your setup",
      includedTitle: "What you can begin with",
      renewalLabel: "Plan selected",
      startLabel: "Setup begins",
      expiryLabel: "Introductory access through",
      freeYearNote:
        "Choose the plan that feels right when you are ready. You can begin organizing first and decide on paid access later.",
      signedInReady:
        "You are signed in. Continue setting up your space when you are ready.",
      emailNotice:
        "We will email a confirmation after access is activated on your account.",
      signInCta: "Sign in to continue",
      registerCta: "Create account to get started",
      signInHelper: "Sign in and we will bring you right back to this plan.",
      enrollPrefix: "Continue with",
      close: "Close",
      successTitle: "Your space is ready",
      successBody:
        "Your introductory access is active now, so you can keep organizing at your own pace.",
      viewProfile: "View in My profile",
      continueBrowsing: "Keep exploring",
      currentPlanBadge: "Access active",
    },
  },
  termsPage: {
    heroEyebrow: "Legal",
    heroTitle: "Terms of Service",
    heroBody:
      "How you may use afterme.ca. This page is available to everyone—copy the link to share with family, advisors, or your records.",
    copyLink: "Copy page link",
    signIn: "Sign in",
    backToDashboard: "Back to dashboard",
    translationNote: "",
    legalKicker: "Legal",
    legalTitle: "Terms of Service",
    legalMetaPrefix: "Effective as of",
    legalDisclaimer:
      "These terms describe how you may use the AfterMe service. They are intended as a practical baseline for a digital legacy platform. They do not replace advice from a lawyer licensed in your province or territory. If anything here conflicts with applicable law, the law governs.",
  },
  upgradeReminder: {
    badge: "Free plan",
    title: "Ready to keep your plan moving forward?",
    body:
      "You are still on the free plan. When you are ready, review paid enrollment so storage, family access, and release workflows can keep growing with you.",
    primaryCta: "View plans",
    secondaryCta: "Not now",
    helper: "We will check back in about 20 minutes while you continue using the app.",
  },
  auth: {
    asideEyebrows: {
      register: "Join AfterMe",
      forgot: "Account recovery",
      reset: "Secure reset",
      login: "Welcome back",
    },
    asideTaglines: {
      register:
        "Create a vault for journals, letters, and memories—released to family only when you intend.",
      recovery:
        "We use email-based recovery so you can regain access without exposing unnecessary data.",
      login:
        "One calm place for your story, your family tree, and who receives what—before anyone needs to guess.",
    },
    bullets: [
      "Private journals and confessions in one vault",
      "Tag family and control post-release access",
      "Media and memories with room to grow",
    ],
    titles: {
      login: "Sign in",
      register: "Create your account",
      forgot: "Forgot password",
      reset: "Choose a new password",
    },
    leads: {
      login:
        "Sign in to build your family tree, save your profile, and manage who can access your legacy.",
      register:
        "Create an account to save your profile, grow your family tree, and choose who can access each part of your legacy.",
      forgot:
        "Enter the email on your account. We will send a link to choose a new password.",
      reset:
        "Enter a new password for your account. You will stay signed out until you sign in again.",
    },
    tabs: {
      login: "Login",
      register: "Register",
      backToSignIn: "← Back to sign in",
    },
    labels: {
      fullName: "Full name",
      email: "Email",
      password: "Password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
    },
    placeholders: {
      fullName: "Full name",
      email: "you@example.com",
      loginPassword: "Password",
      registerPassword: "Choose a strong password",
      newPassword: "At least 8 characters",
      confirmPassword: "Repeat new password",
    },
    buttons: {
      login: "Login",
      register: "Register",
      sending: "Sending…",
      sendResetLink: "Send reset link",
      updating: "Updating…",
      updatePassword: "Update password",
      forgotPassword: "Forgot password?",
      emailMagicLink: "Email me a sign-in link",
      sendingMagicLink: "Sending link…",
      or: "or",
      recommendedSignIn: "Recommended sign-in",
      orUseEmail: "or use email",
      signingIn: "Signing you in…",
    },
    magicLead:
      "Sign in with a one-time link instead of your password. Enter your email above, then request the link.",
    localDevReset: "Local dev:",
    openResetLink: "open reset link",
    localDevSignIn: "Local dev:",
    openSignInLink: "open sign-in link",
  },
  footer: {
    tagline:
      "A secure place to organize your memories, documents, and wishes—so your family has clarity when it matters most.",
    cta: {
      startPlan: "Start your plan",
    },
    productHeading: "Product",
    productOverview: "Product overview",
    how: "How it works",
    security: "Security & privacy",
    pricing: "Pricing",
    faq: "FAQ",
    trustHeading: "Plain-English trust cues",
    trust: {
      encrypted: "Your data is encrypted and stays private",
      control: "You control who sees what—and when",
      noAutoShare: "Nothing is shared automatically",
      thirdParty: "Some services may have their own rules for account access after death.",
    },
    legalHeading: "Contact & legal",
    responseTime: "We reply within 2 business days.",
    terms: "Terms of Service",
    legal: {
      disclaimer:
        "AfterMe provides organization and planning tools only. We do not provide legal, tax, medical, or estate advice. Please consult a qualified professional for personal decisions.",
    },
    copyrightSuffix: "AfterMe · Canada",
  },
  cookie: {
    title: "Cookies & local storage",
    body:
      "We use browser storage to keep you signed in and to remember this choice. We do not sell your data. You can clear site data anytime in your browser settings.",
    essentialOnly: "Essential only",
    accept: "Accept & continue",
  },
};

const FR_COPY = {
  locale: "fr",
  htmlLang: "fr-CA",
  metadata: FR_PAGE_METADATA,
  toggle: {
    label: "Langue",
    english: "EN",
    french: "FR",
  },
  nav: {
    product: "Produit",
    how: "Fonctionnement",
    security: "Securite",
    pricing: "Tarification",
    faq: "FAQ",
    signIn: "Se connecter",
    getStarted: "Commencer",
    myDashboard: "Mon tableau de bord",
    signOut: "Se deconnecter",
    backToHome: "Retour a l'accueil",
  },
  notices: {
    planLinkCopied:
      "Lien copie. Vous pouvez le partager : la page s'ouvre pour les invites comme pour les membres connectes.",
    linkCopyFailed:
      "La copie automatique n'a pas fonctionne. Copiez l'adresse dans la barre du navigateur.",
    termsLinkCopied:
      "Lien des conditions copie. Vous pouvez le partager a toute personne qui a besoin du texte complet.",
    checkoutStub: (label) => `Le paiement pour ${label} n'est pas encore connecte.`,
  },
  homeHero: {
    eyebrow: "Continuite familiale et heritage numerique",
    title: "Aidez votre famille quand elle aura le plus besoin de vous.",
    body:
      "Preservez en toute securite souvenirs, volontes, consignes de confiance et informations importantes pour les personnes qui comptent pour vous.",
    support: "Prive par conception. Partage uniquement avec les personnes que vous choisissez.",
    primaryCta: "Commencer votre plan d'heritage",
    secondaryCta: "Voir le fonctionnement",
  },
  home: {
    video: {
      title: "Voyez comment AfterMe aide votre famille",
      description:
        "Un bref apercu de la facon dont AfterMe garde vos souvenirs, volontes et consignes dans un espace prive et serein.",
      ariaLabel: "Video de presentation d'AfterMe sur la page d'accueil",
      devPlaceholderTitle: "Apercu de la video d'accueil",
      devPlaceholderBody:
        "Ajoutez une URL video d'accueil en developpement local pour afficher l'aperçu ici.",
    },
    why: {
      eyebrow: "Pourquoi AfterMe existe",
      title: "Une facon plus sereine de laisser de la clarte.",
      body:
        "Quand la clarte compte le plus, les informations importantes sont souvent dispersees. AfterMe rassemble souvenirs, volontes et reperes essentiels dans un espace securise.",
      points: [
        "Les documents importants sont plus faciles a retrouver lorsqu'ils restent ensembles.",
        "Les volontes personnelles ne se perdent pas entre notes, courriels et appareils.",
        "Les souvenirs comptent aussi, pas seulement les papiers.",
      ],
    },
    pillars: {
      eyebrow: "Ce que votre plan peut proteger",
      title: "Ce que votre plan aide a preserver",
      body:
        "Gardez l'essentiel ensemble sans submerger les personnes qui comptent pour vous.",
      cards: [
        {
          icon: "🖼️",
          title: "Preserver les souvenirs",
          body: "Conservez photos, notes et messages personnels dans un meme espace prive.",
        },
        {
          icon: "📄",
          title: "Organiser les documents importants",
          body: "Rassemblez les documents dont votre famille pourrait avoir besoin sans les eparpiller partout.",
        },
        {
          icon: "🤝",
          title: "Partager vos volontes avec des personnes de confiance",
          body: "Choisissez qui devrait aider, recevoir des indications ou etre informe plus tard.",
        },
        {
          icon: "🧭",
          title: "Guider votre famille au bon moment",
          body: "Laissez des indications plus claires pour eviter les suppositions dans un moment difficile.",
        },
      ],
    },
    steps: {
      title: "Fonctionnement",
      body: "Commencez simplement, puis avancez a votre rythme.",
      items: [
        {
          step: "01",
          title: "Ajoutez ce qui compte",
          body: "Commencez par un souvenir, un document ou une volonte qui pourrait aider plus tard.",
        },
        {
          step: "02",
          title: "Choisissez les personnes de confiance",
          body: "Choisissez qui peut aider, recevoir quelque chose ou rester informe plus tard.",
        },
        {
          step: "03",
          title: "Gardez tout pret",
          body: "Gardez-le en prive maintenant pour qu'il soit plus facile a retrouver au moment voulu.",
        },
      ],
      cta: "Voir le parcours complet",
    },
    privacy: {
      eyebrow: "Confiance et vie privee",
      title: "Prive par conception. Partage avec soin.",
      body:
        "Les informations familiales sensibles doivent etre protegees, comprehensibles et toujours sous votre controle.",
      cards: [
        {
          icon: "🔒",
          title: "Stockage chiffre",
          body: "Vos souvenirs, documents et notes restent dans un espace protege.",
        },
        {
          icon: "🛡️",
          title: "Controles d'acces prives",
          body: "Vous choisissez qui voit quoi, au lieu de tout partager d'un coup.",
        },
        {
          icon: "👨‍👩‍👧",
          title: "Personnes de confiance uniquement",
          body: "Choisissez les membres de la famille ou les contacts de confiance qui comptent dans votre plan.",
        },
        {
          icon: "⏳",
          title: "Rien n'est partage automatiquement",
          body: "La diffusion peut suivre le moment et les verifications que vous choisissez pour les elements sensibles.",
        },
      ],
      cta: "Revoir la vie privee et l'acces",
    },
    pricing: {
      title: "Choisissez le rythme qui convient a votre famille",
      body:
        "Commencez en douceur, explorez en prive, puis choisissez le forfait qui vous convient seulement lorsque vous serez pret.",
      cards: FR_HOME_PRICING_PREVIEW,
      primaryCta: "Voir les plans et tarifs",
      secondaryCta: "Creer un compte",
      featuredBadge: "Populaire",
    },
    faq: {
      title: "Les premieres questions que se posent les familles",
      body: "Quelques reponses rapides avant de commencer.",
      items: [FR_HOME_FAQS[0], FR_HOME_FAQS[2], FR_HOME_FAQS[4]],
    },
    finalCta: {
      eyebrow: "Commencez en douceur",
      title: "Commencez par un souvenir, un document ou une volonte.",
      body:
        "Vous n'avez pas besoin que tout soit pret aujourd'hui. Commencez petit, puis construisez avec soin.",
      primaryCta: "Creer votre espace securise",
      secondaryCta: "Voir la tarification",
    },
  },
  productShowcase: {
    ariaLabel: "Apercu du produit AfterMe",
    snapshotKicker: "A l'interieur de votre espace securise",
    snapshotTitle: "Souvenirs, documents, personnes de confiance et volontes — prets quand la clarte compte.",
    snapshotStatus: "Prive par conception",
    planItems: [
      {
        title: "Preserver les souvenirs",
        body: "Gardez photos, notes personnelles et messages significatifs dans un meme coffre prive.",
        badge: "Souvenirs",
      },
      {
        title: "Organiser les documents",
        body: "Rassemblez les documents importants pour que votre famille n'ait pas a chercher plus tard.",
        badge: "Documents",
      },
      {
        title: "Consignes pour les proches de confiance",
        body: "Choisissez qui peut aider, verifier ou recevoir des indications sensibles au bon moment.",
        badge: "Personnes de confiance",
      },
    ],
    signalChips: [],
    transitionKicker: "Ce que votre famille peut retrouver",
    transitionTitle: "Un relais plus clair, prepare avec soin",
    transitionItems: [
      { service: "Souvenirs", action: "Histoires personnelles" },
      { service: "Documents", action: "Details importants" },
      { service: "Personnes de confiance", action: "Pretes a aider" },
    ],
    transitionStatusLabel: "Points de repere familiaux",
    transitionStatuses: ["Prive par defaut", "Partage avec permission", "Pret quand il le faut"],
  },
  howPage: {
    kicker: "Fonctionnement",
    title: "Une facon plus sereine de preparer ce dont votre famille pourrait avoir besoin plus tard.",
    lead:
      "AfterMe est concu pour vous aider a preparer du contenu prive, des consignes familiales et des decisions concernant les comptes numeriques au meme endroit afin que les personnes de confiance n'aient pas a improviser.",
    stepsHeading: "Six etapes simples",
    stepsLead:
      "L'experience est construite autour de la clarte : proteger ce qui compte, choisir qui participe et definir ce qui doit se passer avant qu'un moment difficile n'arrive.",
    steps: FR_HOW_IT_WORKS_PAGE_STEPS,
    overviewAria: "Apercu rapide du fonctionnement",
    overviewKicker: "En bref",
    overviewTitle: "D'une preparation privee a une transmission familiale plus claire.",
    overviewGroups: FR_HOW_IT_WORKS_OVERVIEW_GROUPS,
    notesHeading: "Contexte important",
    notes: FR_HOW_IT_WORKS_PAGE_NOTES,
    ctaKicker: "Pret a continuer ?",
    ctaTitle: "Commencez avec la vie privee, des contacts de confiance et une intention de diffusion claire.",
    ctaBody:
      "AfterMe s'adresse aux familles qui veulent plus qu'un simple stockage de fichiers. Il s'adresse a celles et ceux qui veulent un plan plus clair.",
    primaryCta: "Commencer",
    pricingCta: "Voir les tarifs",
    securityCta: "Revoir la securite",
  },
  securityPage: {
    kicker: "Securite et vie privee",
    title: "Prive par defaut. Partage avec soin.",
    lead:
      "Vos informations familiales restent sous votre controle et ne sont partagees qu'avec intention. AfterMe est concu pour rester prive, calme et facile a comprendre.",
    protectsHeading: "Ce qui reste protege",
    protectsLead:
      "Gardez l'essentiel ensemble sans donner l'impression que vos informations familiales sont exposees.",
    protectedItems: [
      {
        title: "Contenu prive",
        body: "Journaux, lettres, souvenirs et notes restent personnels jusqu'a votre decision.",
      },
      {
        title: "Personnes de confiance",
        body: "Vous decidez qui fait partie de votre plan et quel role chaque personne peut avoir plus tard.",
      },
      {
        title: "Diffusion avec soin",
        body: "Des elements precis deviennent accessibles seulement selon le moment et les verifications que vous fixez.",
      },
    ],
    reassuranceAria: "Panneau de reassurance sur la vie privee",
    reassuranceKicker: "Apercu rassurant",
    reassuranceTitle: "Un parcours de vie privee simple pour les informations familiales.",
    reassurancePoints: [
      {
        title: "Prive par defaut",
        body: "Tout commence dans votre espace personnel, pas en acces public.",
      },
      {
        title: "Personnes de confiance seulement",
        body: "Seules les personnes choisies sont reliees a votre plan.",
      },
      {
        title: "Partage avec soin",
        body: "L'acces suit vos regles au lieu de se declencher automatiquement.",
      },
    ],
    reassuranceFlowLabel: "Parcours de securite",
    reassuranceFlow: ["Prive par defaut", "Personnes de confiance seulement", "Partage avec soin"],
    principlesHeading: "Principes simples de vie privee",
    principlesItems: [
      {
        title: "Prive par defaut",
        body: "Vos elements restent dans votre compte tant que vous ne les preparez pas intentionnellement pour quelqu'un d'autre.",
      },
      {
        title: "Personnes de confiance seulement",
        body: "Faire partie de votre plan ne signifie pas tout voir automatiquement.",
      },
      {
        title: "Partage intentionnel",
        body: "Vous choisissez ce qui est partage, avec qui et dans quelles conditions.",
      },
    ],
    contactsHeading: "Ce que les personnes de confiance peuvent et ne peuvent pas faire",
    trustedContacts: [
      {
        title: "Les personnes de confiance peuvent",
        points: [
          "Aider a confirmer les conditions de diffusion",
          "Recevoir des elements precisement partages",
          "Faire partie de votre plan de continuite familiale",
        ],
      },
      {
        title: "Les personnes de confiance ne peuvent pas",
        points: [
          "Acceder automatiquement a tout",
          "Ouvrir un contenu protege trop tot",
          "Controler des comptes tiers sans lien",
        ],
      },
    ],
    verificationHeading: "Comment la diffusion intentionnelle fonctionne",
    verificationLead:
      "Le but est de reduire la confusion, pas de precipiter quoi que ce soit. Le partage reste lie aux personnes et aux verifications que vous choisissez.",
    verificationPaths: [
      { title: "Vous creez du contenu prive", body: "Vous redigez des lettres, conservez des souvenirs ou organisez des informations familiales importantes." },
      { title: "Vous choisissez des personnes de confiance", body: "Vous reliez les personnes qui pourront aider, recevoir des consignes ou rester informees plus tard." },
      { title: "Vos regles de diffusion sont verifiees", body: "Le moment, la confirmation et la revision suivent le parcours que vous avez prepare." },
      { title: "Des elements precis deviennent accessibles intentionnellement", body: "Seuls les elements prevus pour ce moment avancent." },
    ],
    reviewHeading: "Vous gardez le controle sur",
    reviewPoints: [
      "qui peut recevoir du contenu",
      "ce qui reste prive",
      "le moment de diffusion",
      "la structure d'acces familiale",
    ],
    ctaKicker: "Construire avec clarte",
    ctaTitle: "Construisez votre espace familial avec clarte.",
    ctaBody:
      "Commencez en prive, choisissez soigneusement les personnes de confiance et organisez ce qui compte a votre rythme.",
    primaryCta: "Creer votre espace securise",
    howCta: "Voir le fonctionnement",
    pricingCta: "Voir les tarifs",
  },
  pricingPage: {
    heroEyebrow: "Commencez en douceur",
    heroTitle: "Commencez votre espace familial prive.",
    heroBody:
      "Organisez souvenirs, documents importants, contacts de confiance et consignes personnelles a votre rythme.",
    heroPrimaryCta: "Creer votre espace securise",
    heroSecondaryCta: "Voir ce que vous pouvez explorer",
    heroAsideKicker: "Acces d'introduction",
    heroAsideTitle: "Prenez le temps de commencer.",
    heroAsidePoints: [
      "Creez votre espace familial prive",
      "Ajoutez souvenirs, journaux et contacts de confiance",
      "Explorez votre carte familiale et vos outils de planification",
      "Choisissez un forfait seulement lorsque vous serez pret",
    ],
    copyLink: "Copier le lien",
    backToDashboard: "Retour au tableau de bord",
    signIn: "Se connecter",
    promoTitle: "Commencez lentement et explorez en prive",
    promoBody:
      "Vous pouvez commencer a organiser souvenirs, documents, personnes de confiance et consignes personnelles avant toute decision de long terme.",
    promoAssurance: "Aucune facturation surprise ni debit automatique.",
    valueTitle: "Ce que vous pouvez commencer a organiser maintenant",
    valueCards: [
      {
        title: "Preserver les souvenirs",
        body: "Gardez photos, notes et moments familiaux precieux ensemble dans un espace prive.",
      },
      {
        title: "Organiser les documents importants",
        body: "Gardez les informations familiales et les dossiers importants plus faciles a retrouver quand la clarte compte.",
      },
      {
        title: "Choisir des personnes de confiance",
        body: "Decidez qui peut aider, recevoir des consignes ou rester informe lorsque c'est necessaire.",
      },
      {
        title: "Preparer des consignes personnelles",
        body: "Redigez journaux, lettres et volontes dans un endroit calme ou vous pouvez revenir a tout moment.",
      },
    ],
    heading: "Choisissez le rythme qui vous convient",
    comparisonNote:
      "Les deux forfaits soutiennent la meme experience de depart, calme et privee. L'Annuel offre simplement plus d'espace et une valeur plus durable quand vous serez pret.",
    trustTitle: "Concu pour des informations familiales sensibles",
    trustPoints: [
      "Stockage chiffre pour les souvenirs et dossiers sensibles",
      "Controles d'acces prives qui restent sous votre controle",
      "Rien n'est partage automatiquement",
      "Seulement avec les personnes de confiance que vous choisissez",
      "AfterMe ne fournit pas de conseils juridiques, fiscaux, medicaux ou successoraux",
    ],
    trustFootnote:
      "Vous pouvez commencer calmement maintenant et choisir un forfait payant plus tard lorsque ce sera le bon moment.",
    planPrice: {
      introLabel: "Commencez maintenant avec l'acces d'introduction",
      futurePrefix: "Plus tard",
      futureAria: "Commencez maintenant avec l'acces d'introduction. Plus tard {fullLabel}.",
      futureCaption:
        "Aucune facturation surprise ni debit automatique.",
    },
    tiles: [
      {
        id: "monthly",
        name: "Mensuel",
        badge: "Commencer graduellement",
        price: "$9.99",
        period: "/mois",
        lead: "Une option mensuelle douce si vous souhaitez avancer a votre propre rythme.",
        features: [
          "Preserver souvenirs, photos et informations familiales importantes",
          "Journaux prives, profil et carte familiale",
          "Choisir des personnes de confiance qui peuvent aider si besoin",
          "Jusqu'a 2 Go d'espace media securise",
        ],
        cta: "Choisir le Mensuel",
        checkoutLabel: "Acces mensuel lorsque les forfaits payants commenceront",
      },
      {
        id: "annual",
        name: "Annuel",
        badge: "Ideal pour une tranquillite d'esprit durable",
        price: "$99.99",
        period: "/an",
        lead: "Une voie plus stable pour les familles qui veulent un lieu durable pour leurs informations importantes.",
        features: [
          "Tout ce qui est inclus dans Mensuel",
          "Plus d'espace pour les souvenirs, photos et documents",
          "Acces prioritaire aux nouvelles fonctions de securite",
          "Concu pour une continuite familiale sur le long terme",
        ],
        cta: "Choisir l'Annuel",
        checkoutLabel: "Acces annuel lorsque les forfaits payants commenceront",
        featured: true,
      },
    ],
    enrollment: {
      detailsTitle: "Continuer votre installation",
      includedTitle: "Ce avec quoi vous pouvez commencer",
      renewalLabel: "Forfait choisi",
      startLabel: "Installation commence",
      expiryLabel: "Acces d'introduction jusqu'au",
      freeYearNote:
        "Choisissez le forfait qui vous convient lorsque vous serez pret. Vous pouvez d'abord commencer a organiser tranquillement, puis decider plus tard.",
      signedInReady:
        "Vous etes connecte. Continuez a configurer votre espace lorsque vous serez pret.",
      emailNotice:
        "Nous enverrons une confirmation par courriel lorsque l'acces sera active sur votre compte.",
      signInCta: "Se connecter pour continuer",
      registerCta: "Creer un compte pour commencer",
      signInHelper:
        "Nous vous ramenerons a ce forfait apres la connexion.",
      enrollPrefix: "Continuer avec",
      close: "Fermer",
      successTitle: "Votre espace est pret",
      successBody:
        "Votre acces d'introduction est maintenant actif, vous pouvez donc continuer a organiser a votre rythme.",
      viewProfile: "Voir dans Mon profil",
      continueBrowsing: "Continuer a explorer",
      currentPlanBadge: "Acces actif",
    },
  },
  termsPage: {
    heroEyebrow: "Juridique",
    heroTitle: "Conditions d'utilisation",
    heroBody:
      "Voici comment vous pouvez utiliser AfterMe.ca. Cette page est accessible à tous; copiez le lien pour le partager avec votre famille, vos conseillers ou vos dossiers.",
    copyLink: "Copier le lien",
    signIn: "Se connecter",
    backToDashboard: "Retour au tableau de bord",
    translationNote: "",
    legalKicker: "Juridique",
    legalTitle: "Conditions d'utilisation",
    legalMetaPrefix: "En vigueur le",
    legalDisclaimer:
      "Ces conditions décrivent la façon dont vous pouvez utiliser le service AfterMe. Elles constituent une base pratique pour une plateforme d'héritage numérique. Elles ne remplacent pas les conseils d'un avocat autorisé dans votre province ou territoire. En cas de conflit avec la loi applicable, cette dernière prévaut.",
  },
  upgradeReminder: {
    badge: "Forfait gratuit",
    title: "Pret a faire evoluer votre plan ?",
    body:
      "Vous utilisez encore le forfait gratuit. Lorsque vous serez pret, consultez l'inscription payante afin que le stockage, l'acces de la famille et les workflows de diffusion puissent evoluer avec vous.",
    primaryCta: "Voir les forfaits",
    secondaryCta: "Pas maintenant",
    helper:
      "Nous vous le rappellerons dans environ 20 minutes pendant que vous continuez a utiliser l'application.",
  },
  auth: {
    asideEyebrows: {
      register: "Joindre AfterMe",
      forgot: "Recuperation du compte",
      reset: "Reinitialisation securisee",
      login: "Bon retour",
    },
    asideTaglines: {
      register:
        "Creez un coffre-fort pour vos journaux, lettres et souvenirs, diffuses a votre famille seulement quand vous le decidez.",
      recovery:
        "Nous utilisons une recuperation par courriel afin que vous puissiez reprendre l'acces sans exposer inutilement vos donnees.",
      login:
        "Un seul endroit calme pour votre histoire, votre arbre familial et qui recevra quoi, avant que quelqu'un n'ait a deviner.",
    },
    bullets: [
      "Journaux prives et confidences dans un seul coffre-fort",
      "Etiquetez la famille et controlez l'acces apres diffusion",
      "Des medias et souvenirs qui ont de l'espace pour grandir",
    ],
    titles: {
      login: "Se connecter",
      register: "Creer votre compte",
      forgot: "Mot de passe oublie",
      reset: "Choisir un nouveau mot de passe",
    },
    leads: {
      login:
        "Connectez-vous pour construire votre arbre familial, enregistrer votre profil et gerer l'acces a votre heritage.",
      register:
        "Creez un compte pour enregistrer votre profil, faire grandir votre arbre familial et choisir qui peut acceder a chaque partie de votre heritage.",
      forgot:
        "Entrez l'adresse courriel associee a votre compte. Nous vous enverrons un lien pour choisir un nouveau mot de passe.",
      reset:
        "Entrez un nouveau mot de passe pour votre compte. Vous resterez deconnecte jusqu'a votre prochaine connexion.",
    },
    tabs: {
      login: "Connexion",
      register: "Inscription",
      backToSignIn: "← Retour a la connexion",
    },
    labels: {
      fullName: "Nom complet",
      email: "Courriel",
      password: "Mot de passe",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
    },
    placeholders: {
      fullName: "Nom complet",
      email: "vous@exemple.com",
      loginPassword: "Mot de passe",
      registerPassword: "Choisissez un mot de passe solide",
      newPassword: "Au moins 8 caracteres",
      confirmPassword: "Repetez le nouveau mot de passe",
    },
    buttons: {
      login: "Connexion",
      register: "Creer le compte",
      sending: "Envoi…",
      sendResetLink: "Envoyer le lien de reinitialisation",
      updating: "Mise a jour…",
      updatePassword: "Mettre a jour le mot de passe",
      forgotPassword: "Mot de passe oublie ?",
      emailMagicLink: "M'envoyer un lien de connexion",
      sendingMagicLink: "Envoi du lien…",
      or: "ou",
      recommendedSignIn: "Connexion recommandee",
      orUseEmail: "ou utiliser le courriel",
      signingIn: "Connexion en cours…",
    },
    magicLead:
      "Connectez-vous avec un lien a usage unique plutot qu'avec votre mot de passe. Entrez votre courriel ci-dessus, puis demandez le lien.",
    localDevReset: "Dev local :",
    openResetLink: "ouvrir le lien de reinitialisation",
    localDevSignIn: "Dev local :",
    openSignInLink: "ouvrir le lien de connexion",
  },
  footer: {
    tagline:
      "Un espace sécurisé pour organiser vos souvenirs, documents et volontés—afin d’apporter de la clarté à votre famille au moment opportun.",
    cta: {
      startPlan: "Commencer votre plan",
    },
    productHeading: "Produit",
    productOverview: "Apercu du produit",
    how: "Fonctionnement",
    security: "Securite et vie privee",
    pricing: "Tarification",
    faq: "FAQ",
    trustHeading: "Signaux de confiance en langage clair",
    trust: {
      encrypted: "Vos donnees sont chiffrees et restent privees",
      control: "Vous controlez qui voit quoi, et quand",
      noAutoShare: "Rien n'est partage automatiquement",
      thirdParty:
        "Certains services peuvent avoir leurs propres regles concernant l'acces aux comptes apres un deces.",
    },
    legalHeading: "Contact et juridique",
    responseTime: "Nous repondons dans un delai de 2 jours ouvrables.",
    terms: "Conditions d'utilisation",
    legal: {
      disclaimer:
        "AfterMe fournit uniquement des outils d'organisation et de planification. Nous ne fournissons pas de conseils juridiques, fiscaux, medicaux ou successoraux. Veuillez consulter un professionnel qualifie pour toute decision personnelle.",
    },
    copyrightSuffix: "AfterMe · Canada",
  },
  cookie: {
    title: "Temoins et stockage local",
    body:
      "Nous utilisons le stockage du navigateur pour vous garder connecte et memoriser ce choix. Nous ne vendons pas vos donnees. Vous pouvez effacer les donnees du site a tout moment dans les reglages de votre navigateur.",
    essentialOnly: "Essentiels seulement",
    accept: "Accepter et continuer",
  },
};

export const PUBLIC_SITE_COPY = {
  en: EN_COPY,
  fr: FR_COPY,
};

export function getPublicSiteCopy(locale = "en") {
  return PUBLIC_SITE_COPY[locale] || PUBLIC_SITE_COPY.en;
}

export function getPageMetadata(locale = "en", view = "home") {
  const copy = getPublicSiteCopy(locale);
  return copy.metadata[view] || copy.metadata.home;
}
